import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { jobCreationSteps } from '../../../../constants/jobs';
import { getJobTimeDurationUi } from '../../../../helpers/jobs';
import Loader from '../../../common/ui/Loader';
import NavButtons from './NavButtons';
import JobInfo from './LocationScheduleStep/JobInfo';
import mascotImageWarning from '../../../../images/mascot/mascot@2x.png';
import mascotImageSuccess from '../../../../images/mascot/mascot-2@2x.png';

export default class SummaryStep extends Component {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    isLta: PropTypes.bool.isRequired,
    jobSkillData: PropTypes.object.isRequired,
    locationLabel: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    jobsList: PropTypes.arrayOf(
      PropTypes.shape({
        start: PropTypes.object.isRequired,
        startTime: PropTypes.object.isRequired,
        endTime: PropTypes.object.isRequired,
        hours: PropTypes.number.isRequired,
        quantityOfWorkers: PropTypes.number.isRequired
      })
    ),
    selectedWorkersInfoIsShown: PropTypes.bool.isRequired,
    hoursSum: PropTypes.number.isRequired,
    estCostSum: PropTypes.string.isRequired,
    dressCodeLabel: PropTypes.string.isRequired,
    dressCodeInstructions: PropTypes.string.isRequired,
    whereToReport: PropTypes.string.isRequired,
    goToStep: PropTypes.func.isRequired,
    createJobLta: PropTypes.func.isRequired,
    saveJobAsDraft: PropTypes.func.isRequired,
    postJob: PropTypes.func.isRequired
  };

  componentDidMount () {
    window.scrollTo(0, 0);
  }

  render () {
    const { jobSkillData, locationLabel, hoursSum, estCostSum, jobsList, dressCodeLabel, dressCodeInstructions, description,
      whereToReport, goToStep, createJobLta, saveJobAsDraft, postJob, isLoading, selectedWorkersInfoIsShown, isLta } = this.props;
    return (
      <React.Fragment>
        { isLoading ? <Loader /> : (
          <React.Fragment>
            <section className='job-posting-section mt-3 text-center'>
              <img className='mascot-image' src={isLta ? mascotImageSuccess : mascotImageWarning} alt='mascot' />
              <h2 className='mt-4'>{isLta ? 'Good Job!' : 'Almost Done!'}</h2>
              <p className='mb-3'>{isLta ? 'Please click done to post this job' : 'Are you ready to find workers for this job?'}</p>
              { isLta ? (
                <button
                  className='button button-primary button-wide'
                  onClick={createJobLta}
                >Done</button>
              ) : (
                <div className='d-flex justify-content-center flex-wrap'>
                  <div className='mb-2'>
                    <button
                      className='button button-cancel button-wide'
                      onClick={saveJobAsDraft}
                    >
                      Save as Draft
                    </button>
                    <p className='text-muted'>Keep for later</p>
                  </div>
                  <div className='mb-2'>
                    <button
                      className='button button-warning button-wide mx-4'
                      onClick={() => postJob(true)}
                    >
                      Post To Job Board
                    </button>
                    <p className='text-muted'>Notify workers nearby</p>
                  </div>
                  <div className='mb-2'>
                    <button
                      className='button button-primary button-wide'
                      onClick={() => postJob(false)}
                    >
                      Choose Workers
                    </button>
                    <p className='text-muted'>Hire talent</p>
                  </div>
                </div>
              )}
            </section>
            <section className='job-posting-section summary-section'>
              <div className='row mb-3 align-center'>
                <div className='col-12 mb-3 mb-md-0 col-md-4 d-flex align-center'>
                  <div
                    className='job-image'
                    style={{ backgroundImage: `url('${jobSkillData.icon_url}')` }}
                  />
                  <h5>{jobSkillData.skill_label}</h5>
                </div>
                <div className='col-6 col-md-4'>
                  <p>{ getJobTimeDurationUi(hoursSum) }</p>
                  <p className='text-muted'>Total Estimate Hours</p>
                </div>
                <div className='col-6 col-md-4'>
                  <p>{estCostSum}</p>
                  <p className='text-muted'>Total Estimate Pay</p>
                </div>
              </div>
              <div>
                <p>{locationLabel}</p>
                <p className='text-muted'>Job Location</p>
              </div>
              <h5 className='sub-header'>Shifts:</h5>
              <div>
                { jobsList.map(job => (
                  <JobInfo
                    key={job.id}
                    jobData={job}
                    isSummaryStep
                    selectedWorkersInfoIsShown={selectedWorkersInfoIsShown}
                  />
                ))}
              </div>
              <div className='row'>
                { dressCodeLabel && (
                  <div className='col-12 mb-2 mb-sm-0 col-sm-6 col-md-3'>
                    <p>{dressCodeLabel}</p>
                    <p className='text-muted'>Dress Code</p>
                  </div>
                )}
                { dressCodeInstructions && (
                  <div className='col-12 col-sm-6 col-md-9'>
                    <p>{dressCodeInstructions}</p>
                    <p className='text-muted'>Additional Instructions</p>
                  </div>
                )}
              </div>
              <div className='my-3'>
                <p>{description}</p>
                <p className='text-muted'>Description</p>
              </div>
              { whereToReport && (
                <div className='my-3'>
                  <p>{whereToReport}</p>
                  <p className='text-muted'>Additional Instructions</p>
                </div>
              )}
            </section>
            <NavButtons
              goToStep={goToStep}
              backStepId={jobCreationSteps.third.id}
            />
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/createJob/createJob/SummaryStep.js